<div class="lmo-frac-autopilot-engage" *ngIf="currentFrac$ | async as currentFrac">
  <div
    class="engage"
    *ngIf="
      currentFrac.cluster.autopilotLevel === 'off' && ((isFullAuto$ | async) || (isSemiAuto$ | async) || isShaleApps)
    "
  >
    <h1>Engage Autopilot</h1>
    <main>
      <p>Autopilot allows SANDi to make intelligent logistics decisions for you in real time.</p>
      <p>
        SANDi will alert you via an "Autopilot Warning" email when she needs your help, if you are subscribed to the
        Autopilot Notification preferences in settings
      </p>
      <div class="actions">
        <div class="button-row" *ngIf="(isSemiAuto$ | async) || (isFullAuto$ | async)">
          <img src="/assets/icons/lmo-semi-auto.svg" alt="Semi Auto" />
          <sa-network-active-button [active]="(activeNetworkRequest$ | async) && (isSemiDesired$ | async)">
            <button mat-raised-button color="primary" (click)="updateStatus('semi')">
              Engage Auto Ordering
            </button>
          </sa-network-active-button>
        </div>
        <div class="button-row" *ngIf="!(isSemiAuto$ | async) && !(isFullAuto$ | async) && isShaleApps">
          <img src="/assets/icons/lmo-semi-auto.svg" alt="Semi Auto" />
          <sa-network-active-button [active]="(activeNetworkRequest$ | async) && (isSemiDesired$ | async)">
            <button mat-stroked-button color="primary" (click)="updateStatus('semi')">
              (*SA) Engage Auto Ordering
            </button>
          </sa-network-active-button>
        </div>
        <div class="button-row" *ngIf="isFullAuto$ | async">
          <img src="/assets/icons/lmo-full-auto.svg" alt="Full Auto" />
          <sa-network-active-button [active]="(activeNetworkRequest$ | async) && (isFullDesired$ | async)">
            <button mat-raised-button color="primary" (click)="updateStatus('full')">
              Engage Auto Ordering + Auto Assigning
            </button>
          </sa-network-active-button>
        </div>
        <div class="button-row" *ngIf="!(isFullAuto$ | async) && isShaleApps">
          <img src="/assets/icons/lmo-full-auto.svg" alt="Full Auto" />
          <sa-network-active-button [active]="(activeNetworkRequest$ | async) && (isFullDesired$ | async)">
            <button mat-stroked-button color="primary" (click)="updateStatus('full')">
              (*SA) Engage Auto Ordering + Auto Assigning
            </button>
          </sa-network-active-button>
        </div>
      </div>
    </main>
  </div>
  <div class="disengage" *ngIf="currentFrac.cluster.autopilotLevel !== 'off'">
    <h1>Disengage Autopilot</h1>
    <main>
      <p>Autopilot allows SANDi to make intelligent logistics decisions for you in real time.</p>

      <div class="actions">
        <div class="button-row">
          <img src="/assets/icons/lmo-no-auto.svg" alt="No Auto" />
          <sa-network-active-button [active]="activeNetworkRequest$ | async">
            <button mat-raised-button color="warn" (click)="updateStatus('off')">
              Disengage Autopilot
            </button>
          </sa-network-active-button>
        </div>
      </div>
    </main>
  </div>
</div>
